import { defineMessages } from 'react-intl';

export const discoverMessages = defineMessages({
    'discover.title': {
        id: 'discover.title',
        defaultMessage: 'Discover',
        description: 'Title for the discover page.',
    },
    'discover.available_clinical_programs': {
        id: 'discover.available_clinical_programs',
        defaultMessage: 'Available Clinical Programs',
        description: 'Text introducing all of the clinical programs available.',
    },
    'discover.clinical_programs': {
        id: 'discover.clinical_programs',
        defaultMessage: 'Clinical Programs',
        description: 'Header for the clinical programs.',
    },
    'discover.daily_practice': {
        id: 'discover.daily_practice',
        defaultMessage: 'Daily Practice',
        description: 'Header for all of the daily pieces of content.',
    },
    'discover.daily_practice_subtitle': {
        id: 'discover.daily_practice_subtitle',
        defaultMessage:
            'Daily Practices to help you integrate mindfulness into your life',
        description: 'Text introducing the daily practices.',
    },
    'discover.todays_session': {
        id: 'discover.todays_session',
        defaultMessage: "Today's Session",
        description: 'Header for the session of the day.',
    },
    'discover.recent_daily': {
        id: 'discover.recent_daily',
        defaultMessage: 'Recent {dailyType}',
        description: 'header for the recent daily practices.',
    },
});

export default discoverMessages;
